// Smooth-scroll helpers that never touch the URL (one-page site, clean URL).
export function scrollToId(target) {
    if (!target) return;
    const id = target.startsWith("#") ? target : `#${target}`;
    const el = document.querySelector(id);
    if (!el) return;
    if (window.__lenis) {
        window.__lenis.scrollTo(el, { offset: -10, duration: 1.4 });
    } else {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
    }
}

export function scrollToTop() {
    if (window.__lenis) {
        window.__lenis.scrollTo(0, { duration: 1.4 });
    } else {
        window.scrollTo({ top: 0, behavior: "smooth" });
    }
}
